export default __webpack_public_path__ + "static/media/PPI-firefeature-010.9db2a4dc.jpg";